import { render } from "./I.vue?vue&type=template&id=1d116dc4"
import script from "./I.vue?vue&type=script&lang=js"
export * from "./I.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__